import { Flex, Form } from "antd";
import { Link } from "react-router-dom";

import Button from "@ui/form-controls/button";
import AuthShell from "../auth-shell";

import { useCompletePasswordReset } from "../../hooks/use-complete-password-reset";

import TextField from "@ui/form-controls/text-field";

const CompletePasswordResetForm = () => {
  const { alertType, handleSubmit, loading, message } = useCompletePasswordReset();

  return (
    <AuthShell
      alertType={alertType}
      loading={loading}
      message={message}
      pageClassName="min-h-screen min-w-[100vw] m-0 bg-white overflow-y-scroll"
      spinClassName="loaderGifPosition min-w-[80%]"
      title="Complete Reset Password"
    >
      <Form
        name="drs-complete-reset-pw"
        className="complete-reset-pw-form"
        autoComplete="off"
        onFinish={handleSubmit}
      >
        <Form.Item
          labelCol={{ span: 24 }}
          label="New Password"
          name="newPassword"
          fieldKey="newPassword"
          className="emailInput"
          rules={[
            { min: 6, message: "Password must be minimum 6 characters." },
            {
              required: true,
              message: "Please input your password!"
            }
          ]}
        >
          <TextField placeholder="New Password" type="password" size="lg" />
        </Form.Item>

        <Form.Item
          labelCol={{ span: 24 }}
          className="emailInput"
          label="Confirm Password"
          name="confirmPassword"
          fieldKey="Password"
          rules={[
            {
              required: true,
              message: "Please confirm your password!"
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }

                return Promise.reject(new Error("Passwords do not match"));
              }
            })
          ]}
        >
          <TextField placeholder="Confirm Password" type="password" size="lg" />
        </Form.Item>

        <Flex vertical gap={10} justify="center" align="center" className="mt-5">
          <Button size="lg" variant="primary" htmlType="submit" className="w-full">
            Submit
          </Button>
          <Link type="primary" to="/login" className="login-form-button">
            Home
          </Link>
        </Flex>
      </Form>
    </AuthShell>
  );
};

export default CompletePasswordResetForm;
